import React from 'react'

import { Body1, Caption1 } from '@ui/Typography'
import { IconButton } from '@ui/components/Button'
import { CloseIcon } from '@ui/icons/Close.icon'

import { Box } from '@shared/components/Box/Box'

import styles from './CardTradingView.module.scss'

export interface TradeCardRowProps {
  sideLabel: React.ReactNode
  rightPrimary?: React.ReactNode
  caption?: React.ReactNode
  meta?: React.ReactNode
  onClick?(): void
  onClose?(): void
  actionsRight?: React.ReactNode
  className?: string
}

export const TradeCardRow: React.FC<TradeCardRowProps> = ({
  sideLabel,
  rightPrimary,
  caption,
  meta,
  onClose,
  onClick,
  actionsRight,
  className,
}) => {
  return (
    <Box
      flex
      align='center'
      justify='space-between'
      radius='x16'
      gap='x12'
      pl='x16'
      pr='x10'
      py='x12'
      className={[styles.outlined, styles.tradeItem, className].filter(Boolean).join(' ')}
      onClick={() => {
        onClick?.()
      }}
    >
      <Box flex direction='column' className={styles.flexGrowBox}>
        <Box flex justify='space-between' align='center'>
          <Body1 medium>{sideLabel}</Body1>
          {rightPrimary}
        </Box>
        {caption && <Caption1 color='text-med-em'>{caption}</Caption1>}
        {meta}
      </Box>
      {actionsRight !== undefined ? (
        actionsRight
      ) : onClose ? (
        <IconButton.Ghost
          aria-label={'Close'}
          onClick={(e) => {
            e.stopPropagation()
            onClose()
          }}
          icon={{ icon: CloseIcon, color: 'text-med-em' }}
        />
      ) : null}
    </Box>
  )
}

export default TradeCardRow
